import React from "react";

function useTermlyScriptHook() {
  const isProduction = process.env.REACT_APP_ENV === "production";
  React.useEffect(() => {
    if (isProduction && !document.querySelector("#termly-script")) {
      let headElem = document.getElementsByTagName("head")[0];
      const script = document.createElement("script");
      script.src =
        "https://app.termly.io/resource-blocker/80fd4584-07bd-4100-962f-288e652b3a0e?autoBlock=on";
      script.id = "termly-script";
      script.type = "text/javascript";
      script.async = true;
      headElem.insertBefore(script, headElem.firstChild);
    }
  }, [isProduction]);

  return {};
}

export default useTermlyScriptHook;
